import { useState } from 'react';
import { initialsFromEmail } from '../lib/userName';

/**
 * The signed-in user's avatar: the Microsoft profile photo when the gateway has one, otherwise
 * (or when it fails to load) the two initials. The adjacent name labels it.
 */
export function AccountAvatar({
  email,
  photoUrl,
}: {
  email: string;
  photoUrl?: string | null | undefined;
}) {
  const [failed, setFailed] = useState(false);
  return (
    <span className="nv-av" aria-hidden="true">
      {photoUrl && !failed ? (
        <img src={photoUrl} alt="" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
      ) : (
        initialsFromEmail(email)
      )}
    </span>
  );
}
